import { AxiosInstance, AxiosResponse } from 'axios'
import { UserService } from './ext/user'
import { PromoService } from './ext/promo'
import { LeadRequestService } from './ext/lead-request'
import { FoxfordConfig, FoxfordEvents, IFoxford } from '../../index.d'
import { Api } from '../api'
import { TagService } from './ext/tag'
import { CartService } from './ext/cart'
import { HOST } from './constants'
import { CourseService } from './ext/course'
import { ProductPackService } from './ext/product-pack'
import { Widgets } from './ext/widgets'
import { AppOptionsService } from './ext/app-options'

const DEFAULT_CONFIG: FoxfordConfig = {
  host: HOST,
  widgetsVersion: 'latest',
}

export class Foxford implements IFoxford {
  api: AxiosInstance
  user: UserService
  tag: TagService
  cart: CartService
  promo: PromoService
  course: CourseService
  productPack: ProductPackService
  leadrequest: LeadRequestService
  widgets: Widgets
  appOptions: AppOptionsService
  private _config: FoxfordConfig

  static events: FoxfordEvents = Object.freeze({
    SET_APP_OPTIONS: 'Foxford.app_options.set',
  })

  constructor(config: FoxfordConfig = DEFAULT_CONFIG) {
    this._config = config

    if (this._config.host) Api.defaults.baseURL = this._config.host

    this.user = new UserService()
    this.promo = new PromoService()
    this.tag = new TagService()
    this.cart = new CartService()
    this.course = new CourseService()
    this.widgets = new Widgets(config.widgetsVersion)
    this.productPack = new ProductPackService()
    this.leadrequest = new LeadRequestService()
    this.appOptions = new AppOptionsService()

    this.api = Api
  }

  /**
   * Get short link
   * @param {string} url link for shortening
   */
  shortURL(url: string): Promise<AxiosResponse<unknown>> {
    return Api.post(`/api/short_urls`, {
      link: url,
    }).then((data) => data)
  }
}
